// extracted by mini-css-extract-plugin
export default {"howManyFilterrContainer":"howManyFilterrContainer__1FH8s","filterLabel":"filterLabel__2L8Tj","howManyFilter":"howManyFilter__3xHXr","quantity-button":"quantity-button__tnun9","quantity":"quantity__2WncT","minus":"minus__1S8mb","plus":"plus__3H8Fy"};
    if(module.hot) {
      // 1778491679973
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  